module.exports = __webpack_public_path__ + "img/logo.36083d01.png";